export default __webpack_public_path__ + "images/walmart-collapse.svg";